<template>
  <div class="upload">
    <headTop head-title='实名认证' go-back="true"></headTop>
    <div class="content">
      <ul class="status border-1px" v-if="userInfo">
        <li class="on">
          提交认证
          <span class="on"></span>
        </li>
        <li class="fill" :class="{on: Number(userInfo.auth_status) != 0}"></li>
        <li :class="{on: Number(userInfo.auth_status) != 0}">
          认证审核
          <span class="ic-2"></span>
        </li>
        <li class="fill" :class="{on: Number(userInfo.auth_status) == 1}"></li>
        <li :class="{on: Number(userInfo.auth_status) == 1}">
          审核通过
          <span class="ic-3"></span>
        </li>
      </ul>
      <div class="wrap" v-if="userInfo">
        <div v-if="Number(userInfo.auth_status) == 0">
          <ul class="list" >
            <li class="border-1px">
              <span><b>*</b>银行卡:</span>
              <div class="up-btn">
                <span class="icon"></span>
                <p>银行卡</p>
                <input class="file" type="file" accept="image/*" @change="selectBankC" ref="fileinput">
              </div>
              <div class="up-pic">
                <img alt="" v-if="form.bank_card" ref="img">
                <span v-if="form.bank_card" class="del" @click="cleanBankC"></span>
                <div class="dashed" v-else></div>
              </div>
            </li>
            <li class="border-1px">
              <span><b>*</b>身份证:</span>
              <div class="up-btn">
                <span class="icon"></span>
                <p>正面</p>
                <input class="file" type="file" accept="image/*" @change="selectIDCF" ref="fileinput2">
              </div>
              <div class="up-pic">
                <img alt="" v-if="form.ID_card_front" ref="img2">
                <span v-if="form.ID_card_front" class="del" @click="cleanIDCF"></span>
                <div class="dashed" v-else></div>
              </div>
            </li>
            <li class="border-1px">
              <span><b>*</b>身份证:</span>
              <div class="up-btn">
                <span class="icon"></span>
                <p>反面</p>
                <input class="file" type="file" accept="image/*" @change="selectIDCB" ref="fileinput3">
              </div>
              <div class="up-pic">
                <img alt="" v-if="form.ID_card_back" ref="img3">
                <span v-if="form.ID_card_back" class="del" @click="cleanIDCB"></span>
                <div class="dashed" v-else></div>
              </div>
            </li>
            <li class="border-1px">
              <span><b>*</b>卡主姓名:</span>
              <input class="text" type="text" placeholder="请输入姓名" v-model="form.name">
            </li>
          </ul>
          <button class="submit" @click="submit">提交认证</button>
        </div>
        <div class="show" v-else>
          <template v-if="Number(userInfo.auth_status) == 1">
            <span class="success"></span>
            <p>恭喜您</p>
            <p>您已审核成功</p>
          </template>
          <template v-else>
            <span class="on"></span>
            <p>提交成功</p>
            <p>管理员正在审核</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from '@/components/common/header/head'
import { userResource } from '@/resource/resource'
import { mapState, mapMutations } from 'vuex'

const ERR_OK = 0

export default {
  name: 'upload',
  computed: {
    ...mapState(['userInfo', 'logined', 'config_info'])
  },
  data () {
    return {
      form: {
        name: '',
        bank_card: null,
        ID_card_front: null,
        ID_card_back: null
      },
      picSize: 2
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    cleanBankC() {
      this.form.bank_card = null
    },
    cleanIDCF() {
      this.form.ID_card_front = null
    },
    cleanIDCB() {
      this.form.ID_card_back = null
    },
    fileSize(file, item, name, fName) {
      let fileSize = file.size / 1024
      if (fileSize > (this.picSize * 1024)) {
        if (!window.FileReader || !window.Blob) {
          this.$toast(`图片大小不能超过${this.picSize}MB`)
          this.$refs[fName].value = ''
          return
        }
      }
      this.form[item] = file
      this.readFile(file, name, item)
    },
    readFile(file, name, item, callback) {
      let self = this
      let reader = new FileReader()
      reader.readAsDataURL(file)
      // console.log('********原始图片文件********')
      // console.log(file)
      reader.onload = (e) => {
        self.$refs[name].src = e.target.result
        let fileSize = file.size / 1024
        self.form[`${item}_name`] = file.name
        if (fileSize > (this.picSize * 1024)) {
          let result = e.target.result
          let img = new Image()
          img.src = result
          // console.log('********未压缩前的图片大小********')
          // console.log(result.length / 1024 / 1024)
          img.onload = () => {
            let data = self.compress(img)
            let blob = self.dataURItoBlob(data)
            // console.log('*******base64转blob对象******')
            // console.log(blob)
            // console.log(blob.size / 1024 / 1024)
            self.form[item] = blob
            self.form[`${item}_name`] = new Date().getTime() + '.jpeg'
          }
        }
      }
    },
    selectBankC(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0]  // 提交的图片
        this.fileSize(file, 'bank_card', 'img', 'fileinput')
      }
    },
    selectIDCF(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0]  // 提交的图片
        this.fileSize(file, 'ID_card_front', 'img2', 'fileinput2')
      }
    },
    selectIDCB(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0]  // 提交的图片
        this.fileSize(file, 'ID_card_back', 'img3', 'fileinput3')
      }
    },
    submit() {
      if (!this.form.bank_card) {
        this.$toast('请选择银行卡照片')
        return
      } else if (!this.form.name) {
        this.$toast('姓名不能为空')
        return
      } else if (!this.form.ID_card_front) {
        this.$toast('请选择身份证正面照片')
        return
      } else if (!this.form.ID_card_back) {
        this.$toast('请选择身份证反面照片')
        return
      }
      // console.log(this.form)
      let formData = new FormData()
      formData.append('UploadForm[bank_card]', this.form.bank_card, this.form.bank_card_name)
      formData.append('UploadForm[name]', this.form.name)
      formData.append('UploadForm[ID_card_front]', this.form.ID_card_front, this.form.ID_card_front_name)
      formData.append('UploadForm[ID_card_back]', this.form.ID_card_back, this.form.ID_card_back_name)
      userResource.upload(formData).then(res => {
        res = res.body
        if (res.errcode === ERR_OK) {
          this.$messagebox.alert(res.data).then(action => {
            this.getUserInfo()
          })
        }
      })
    },
    // 压缩图片
    compress(img) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      // let initSize = img.src.length
      // console.log(initSize)
      let width = img.width / 2
      let height = img.height / 2
      canvas.width = width
      canvas.height = height
      // 铺底色
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, width, height)

      // 进行最小压缩
      let ndata = canvas.toDataURL('image/jpeg', 0.92)
      // console.log('*******压缩后的图片大小*******')
      // console.log(ndata)
      // console.log(ndata.length)
      return ndata
    },
    // base64转成bolb对象
    dataURItoBlob(base64Data) {
      var byteString
      if (base64Data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(base64Data.split(',')[1])
      } else {
        byteString = unescape(base64Data.split(',')[1])
      }
      var mimeString = base64Data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },
    getUserInfo() {
      userResource.info().then(res => {
        res = res.body
        if (res.errcode === ERR_OK) {
          this.AUTO_USERINFO(res.data)
        }
      })
    },
    ...mapMutations([
      'AUTO_USERINFO'
    ])
  },
  components: {
    headTop
  }
}
</script>

<style lang="stylus" scoped>
@import "../../common/stylus/mixin"
.upload
  position fixed
  left 0
  top 0
  right 0
  background #fff
  height 100%
  overflow auto
  .content
    padding-top 0.9rem
    .status
      display flex
      height 0.88rem
      color $c-b3
      font-size $fz-t3
      border-1px(#f4f4f4)
      border-left-none()
      border-right-none()
      border-top-none()
      justify-content space-between
      align-items center
      padding-left 0.48rem
      padding-right 0.48rem
      & > li
        display flex
        align-items center
        & > span
          // display inline-block
          width 0.24rem
          height 0.24rem
          background-size 0.24rem 0.24rem
          margin-left 0.08rem
          bg-image('1')
          &.ic-2
            bg-image('2')
          &.ic-3
            bg-image('3')
      .on
        color $blue
        .ic-2
          bg-image('2b')
        .ic-3
          bg-image('3b')
      .fill
        width 0.8rem
        height 0.02rem
        background $c-b3
        &.on
          background $blue
    .wrap
      .list
        & > li
          border-1px(#f4f4f4)
          border-left-none()
          border-right-none()
          border-top-none()
          padding 0.32rem 0.28rem
          font-size $fz-t3
          color $c-b3
          display flex
          .text
            z-index 1000
            border 0
            outline 0
          & > span
            margin-right 0.26rem
            & > b
              color $c-r
              margin-right 0.12rem
          .up-btn
            position relative
            width 1.94rem
            height 1.94rem
            border .02rem dashed #ccc
            margin-right 0.28rem
            text-align center
            .icon
              display block
              width 0.32rem
              height 0.32rem
              bg-image('add')
              background-size 0.32rem 0.32rem
              margin 0.53rem auto 0.32rem
            .file
              width 1.98rem
              height 1.98rem
              position absolute
              z-index 1000
              top 0
              left 0
              right 0
              opacity 0
          .up-pic
            width 3.2rem
            height 1.98rem
            position relative
            & > img
              width 100%
              height 100%
            .del
              position absolute
              top -0.12rem
              right 0
              width 0.24rem
              height 0.24rem
              bg-image('del')
              background-size 0.24rem 0.24rem
              z-index 1000
            .dashed
              width 3.16rem
              height 1.94rem
              border .02rem dashed #ccc
      .submit
        display block
        background $blue
        margin 0.8rem auto
        border-radius 0.06rem
        color #fff
        font-size $fz-t5
        width 6.96rem
        border 0
        height 0.88rem
      .show
        font-size 0.4rem
        color $blue
        text-align center
        & > span
          display block
          width 2.4rem
          height 2.4rem
          margin 3.34rem auto 0.64rem
          background-size 2.4rem 2.4rem
          &.on
            bg-image('ing')
          &.success
            bg-image('success')
        & > p
          line-height 0.44rem
</style>





// WEBPACK FOOTER //
// src/components/upload/upload.vue